import React, { Fragment, useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import { Button, FormFeedback, Input, Label } from "reactstrap";
import { resetPassword } from "../../services/developer";
import { useFormik } from "formik";
import * as Yup from 'yup';
import { Form } from "react-router-dom";
import i18next from "i18next";
import NotificationModal from "../../Components/Common/NotificationModal";

function ResetPasswordTab(props) {
    const { t } = useTranslation();
    document.title = t('PageMain.DocumentTitle');
    const [oldPasswordShow, setOldPasswordShow] = useState(false);
    const [newPasswordShow, setNewPasswordShow] = useState(false);
    const [isUpdateDone, setIsUpdateDone] = useState(true);
    const [isShowConfirmModal, setShowConfirmModal] = useState(false);

    console.log("isUpdateDone: ", isUpdateDone);

    const validationSchema = React.useMemo(() => {
        return Yup.object({
            username: Yup.string().required(t('PageDeveloper.ResetPassword.usernameRequired')),
            oldPassword: Yup.string()
                .required(t("PageDeveloper.ResetPassword.oldPasswordRequired"))
                .min(8, t("PageDeveloper.ResetPassword.oldPasswordLength"))
                .max(20, t("PageDeveloper.ResetPassword.oldPasswordLength")),
            newPassword: Yup.string()
                .required(t("PageDeveloper.ResetPassword.newPasswordRequired"))
                .min(8, t("PageDeveloper.ResetPassword.newPasswordLength"))
                .max(20, t("PageDeveloper.ResetPassword.newPasswordLength"))
        });
    }, [t]);

    const validation = useFormik({
        enableReinitialize: true,
        validateOnMount: true,
        initialValues: {
            username: "",
            oldPassword: "",
            newPassword: "",
        },
        validationSchema,
        onSubmit: (values, { resetForm }) => {
            resetPassword(values.username, values.oldPassword, values.newPassword).then((res) => {
                if (res.data) {
                    resetForm();
                    setIsUpdateDone(true);
                    setShowConfirmModal(true);
                }
                else {
                    setIsUpdateDone(false);
                }
            }
            ).catch((err) => {
                console.log(err);
                setIsUpdateDone(false);
            });
        }
    });

    useEffect(() => {
        validation.validateForm();
    }, [i18next.language]);

    React.useEffect(() => {
        setIsUpdateDone(null);
    }, [validation.values]);

    useEffect(() => {
        validation.resetForm();
    }, [props.developerTab]);

    return (
        <Fragment>
            {/*{error && error ? (<Alert color="danger"> {t('PageLogin.LoginFailedMsg')} </Alert>) : null}*/}
            <Form
                onSubmit={(e) => {
                    e.preventDefault();
                    validation.handleSubmit();
                    return false;
                }}
                action="#" id="reset-password-form">

                <div className="mb-3">
                    <Label htmlFor="username" className="form-label">{t('PageLogin.Username')}</Label>
                    <Input
                        name="username"
                        className="form-control"
                        placeholder={t('PageLogin.UsernamePlaceholder')}
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.username || ""}
                        invalid={
                            validation.touched.username && validation.errors.username ? true : false
                        }
                    />
                    {validation.touched.username && validation.errors.username ? (
                        <FormFeedback type="invalid">{validation.errors.username}</FormFeedback>
                    ) : null}
                </div>

                <div className="mb-3">
                    <Label className="form-label" htmlFor="old-password-input">{t('PageDeveloper.ResetPassword.OldPassword')}</Label>
                    <div className="position-relative auth-pass-inputgroup mb-3">
                        <Input
                            name="oldPassword"
                            value={validation.values.oldPassword || ""}
                            type={oldPasswordShow ? "text" : "password"}
                            className="form-control pe-5"
                            placeholder={t('PageDeveloper.ResetPassword.OldPasswordPlaceholder')}
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            invalid={
                                validation.touched.oldPassword && validation.errors.oldPassword ? true : false
                            }
                        />
                        {validation.touched.oldPassword && validation.errors.oldPassword ? (
                            <FormFeedback type="invalid">{validation.errors.oldPassword}</FormFeedback>
                        ) : null}
                        <button className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted" type="button" onClick={() => setOldPasswordShow(!oldPasswordShow)} id="password-addon"><i className="ri-eye-fill align-middle"></i></button>
                    </div>
                </div>

                <div className="mb-3">
                    <Label className="form-label" htmlFor="new-password-input">{t('PageDeveloper.ResetPassword.NewPassword')}</Label>
                    <div className="position-relative auth-pass-inputgroup mb-3">
                        <Input
                            name="newPassword"
                            value={validation.values.newPassword || ""}
                            type={newPasswordShow ? "text" : "password"}
                            className="form-control pe-5"
                            placeholder={t('PageDeveloper.ResetPassword.NewPasswordPlaceholder')}
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            invalid={
                                validation.touched.newPassword && validation.errors.newPassword ? true : false
                            }
                        />
                        {validation.touched.newPassword && validation.errors.newPassword ? (
                            <FormFeedback type="invalid">{validation.errors.newPassword}</FormFeedback>
                        ) : null}
                        <button className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted" type="button" onClick={() => setNewPasswordShow(!newPasswordShow)} id="password-addon"><i className="ri-eye-fill align-middle"></i></button>
                    </div>
                </div>
                {isUpdateDone ? 
                <div style={{ textAlign: 'center', marginBottom: -10 }}>
                    <Label style={{ color: "orange", marginBottom: 0 }}>{t('PageDeveloper.ResetPassword.SuccessMsg')}</Label>
                </div> : 
                isUpdateDone !== null ? 
                    <div style={{ textAlign: 'center', marginBottom: -10 }}>
                        <Label style={{ color: "red", marginBottom: 0 }}>{t('PageDeveloper.ResetPassword.ErrorMsg')}</Label>
                    </div> : null
                }
                <div className="mt-4">
                    <Button color="success" className="btn btn-success w-100" type="submit">
                        {t("PageDeveloper.ResetPassword.ResetBtn")}
                    </Button>
                </div>
                <NotificationModal
                    show={isShowConfirmModal} 
                    onCloseClick={()=>{setShowConfirmModal(false);}} 
                    onButtonClick={()=>{setShowConfirmModal(false);}}
                    title={t('PageDeveloper.Tab.ResetPassword')}
                    description={t('PageDeveloper.ResetPassword.SuccessMsg')}
                    isWithCancelBtn={false}
                    buttonTitle={t('Common.Btn.Confirm')}
                />
            </Form>
        </Fragment>
    );
}

export default ResetPasswordTab;